import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Route2b = ({
  width = 634,
  height = 454,
  stroke = colors.light,
  opacity = 1,
  offset = 0,
  pathLength = 1829,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 641 454"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        strokeWidth="3"
        stroke={stroke}
        opacity={opacity}
        ref={forwardRef}
        strokeDashoffset={offset * pathLength}
        strokeDasharray={pathLength}
        d="M660 294C636.667 292.667 586 297.6 570 328C550 366 566.561 374.466 598 372C623.5 370 634.5 391 622.5 418C610.5 445 569 465 557 442C545 419 481 411 462 410C443 409 448.5 403.5 462 403.5C475.5 403.5 497.5 379.5 499 346.5C500.5 313.5 478 316.5 462 285.5C446 254.5 440 249.5 424 248C408 246.5 378.5 248 366.5 253.5C354.5 259 355.5 249.5 357.5 242.5C359.5 235.5 347 231.5 308.5 231.5C270 231.5 236.5 201 233 178.5C230.2 160.5 242 147.001 265 137.5C283.5 129.859 308.6 122.9 303 110.5C296 95.0001 289.5 86.5001 299 77.0001C308.5 67.5001 336.5 50.5001 329.5 27.0001C322.5 3.50011 330 2.49971 333 1.50011C339 -0.499171 347.5 9.00011 350 20.0001C352.5 31.0001 369 42.4999 391.5 27.0001C414 11.5003 421 11.4999 426 18.4999C436 32.4997 380.5 69.5003 344.5 80.0003C308.5 90.5003 280 110.501 268 144.5C256 178.5 247.5 219 209.5 178.5C171.5 138 153.5 141.5 136 152.5C118.5 163.5 99 190 75.5 152.5C52 115 34.5 54 0.5 73.5"
      />
    </svg>
  )
}

export default Route2b
